import { render, staticRenderFns } from "./TemplateMenu.vue?vue&type=template&id=71569d4e&scoped=true&"
import script from "./TemplateMenu.vue?vue&type=script&lang=js&"
export * from "./TemplateMenu.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMenu.vue?vue&type=style&index=0&id=71569d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71569d4e",
  null
  
)

export default component.exports